import { apiRequest, readJsonOrThrow } from "@/api/client";

export async function fetchSubscriptionStatus(session) {
  const response = await apiRequest("/momo/ecartpay/subscriptions/status", {
    session,
    includeContentType: false,
  });
  return readJsonOrThrow(response, "Failed to fetch subscription status");
}
